import { render } from "./InfoCard.vue?vue&type=template&id=f36c5b6c"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__